import Vue from 'vue'
import vueXlsxTable from 'vue-xlsx-table'
import VuetifyConfirm from 'vuetify-confirm'
import DatetimePicker from 'vuetify-datetime-picker'
import LoadScript from 'vue-plugin-load-script'
import VueApexCharts from 'vue-apexcharts'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './plugins/base'
import '@/plugins/register-service-worker'
import './assets/fonts/fonts.css'

Vue.config.productionTip = false
Vue.use(vueXlsxTable, { rABS: false })
Vue.use(VuetifyConfirm, {
  vuetify
})
Vue.use(DatetimePicker)
Vue.use(LoadScript)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.prototype.$Tawk_API = window.Tawk_API

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
